var Feature = /* @__PURE__ */ ((Feature2) => {
  Feature2["LOCAL_PROFILES"] = "Local Profiles";
  Feature2["LOCAL_MARKETING"] = "Local Marketing";
  Feature2["LOCAL_PROGRAM"] = "Local Program";
  return Feature2;
})(Feature || {});
var Activity = /* @__PURE__ */ ((Activity2) => {
  Activity2["MANAGE_PROFILE"] = "Manage Profile";
  Activity2["MANAGE_PROFILE_FULFILLMENT"] = "Manage Profile Fulfillment";
  Activity2["MANAGE_PROFILE_CATALOG"] = "Manage Profile Catalog";
  Activity2["MANAGE_CAMPAIGN"] = "Manage Campaign";
  Activity2["VIEW_PERFORMANCE"] = "View Performance";
  Activity2["VIEW_NEIGHBORHOODS"] = "View Neighborhoods";
  Activity2["CREATE_MESSAGE"] = "Create Message";
  Activity2["MESSAGE_MANAGEMENT"] = "Message Management";
  Activity2["NEIGHBORHOODS_NUX"] = "Neighborhoods NUX";
  Activity2["NEIGHBORHOODS_PRE_LIVE"] = "Neighborhoods Pre Live";
  return Activity2;
})(Activity || {});
var EventName = /* @__PURE__ */ ((EventName2) => {
  EventName2["VIEW_LOCAL_PROFILE_MANAGEMENT"] = "View Local Profile Management";
  EventName2["VIEW_LOCAL_PROFILE_SETTINGS"] = "View Local Profile Settings";
  EventName2["CLICK_LOCAL_PROFILE_START_ONBOARDING"] = "Click Local Profile Start Onboarding";
  EventName2["VIEW_LOCAL_PROFILE_LIVE_PROFILE_MODAL"] = "View Local Profile Live Profile Modal";
  EventName2["CLICK_LOCAL_PROFILE_ENABLE_ORDERING"] = "Click Local Profile Enable Ordering";
  EventName2["CLICK_LOCAL_PROFILE_DISABLE_ORDERING"] = "Click Local Profile Disable Ordering";
  EventName2["CLICK_LOCAL_PROFILE_CONFIRM_LOCATION"] = "Click Local Profile Confirm Location";
  EventName2["CLICK_LOCAL_PROFILE_ENABLE_FULFILLMENT"] = "Click Local Profile Enable Fulfillment";
  EventName2["VIEW_LOCAL_PROFILE_LOCATION_CONFIRMATION_MODAL"] = "View Local Profile Location Confirmation Modal";
  EventName2["CLICK_LOCAL_PROFILE_LOCATION_CONFIRMATION_MODAL_SAVE_ADDRESS"] = "Click Local Profile Location Confirmation Modal Save Address";
  EventName2["CLICK_LOCAL_PROFILE_ADD_MENU"] = "Click Local Profile Add Menu";
  EventName2["CLICK_LOCAL_PROFILE_ADD_FLOOR_PLAN"] = "Click Local Profile Add Floor Plan";
  EventName2["CLICK_LOCAL_PROFILE_CLICK_DOWNLOAD"] = "Click Local Profile Click Download";
  EventName2["CLICK_LOCAL_PROFILE_CLICK_FLOOR_PLAN"] = "Click Local Profile Click Floor Plan";
  EventName2["CLICK_LOCAL_PROFILE_CLICK_PRINT"] = "Click Local Profile Click Print";
  EventName2["CLICK_LOCAL_PROFILE_GET_CODES"] = "Click Local Profile Get Codes";
  EventName2["VIEW_NEIGHBORHOODS_TAB"] = "View Neighborhoods Tab";
  EventName2["PAUSE_NEIGHBORHOOD_CAMPAIGN"] = "Pause Neighborhood Campaign";
  EventName2["PAUSE_NEIGHBORHOOD_CAMPAIGN_CONFIRM"] = "Pause Neighborhood Campaign Confirm";
  EventName2["PAUSE_NEIGHBORHOOD_CAMPAIGN_CANCEL"] = "Pause Neighborhood Campaign Cancel";
  EventName2["RESUME_NEIGHBORHOOD_CAMPAIGN"] = "Resume Neighborhood Campaign";
  EventName2["RESUME_NEIGHBORHOOD_CAMPAIGN_CONFIRM"] = "Resume Neighborhood Campaign Confirm";
  EventName2["RESUME_NEIGHBORHOOD_CAMPAIGN_CANCEL"] = "Resume Neighborhood Campaign Cancel";
  EventName2["CLICK_LOCAL_PROFILE_JOIN_NEIGHBORHOODS"] = "Click Local Profile Join Neighborhoods";
  EventName2["CLICK_LOCAL_PROFILE_LEARN_MORE_NEIGHBORHOODS"] = "Click Local Profile Learn More About Neighborhoods";
  EventName2["CLICK_LOCAL_PROFILE_LEARN_MORE_QR_CODES"] = "Click Local Profile Learn More About QR Codes";
  EventName2["CLICK_LOCAL_PROFILE_CONNECT_GOOGLE_ORDERING"] = "Click Local Profile Connect Google Ordering";
  EventName2["CLICK_LOCAL_PROFILE_MANAGE_GOOGLE_ORDERING"] = "Click Local Profile Manage Google Ordering";
  EventName2["VIEW_LOCAL_PROFILE_FTUX"] = "View Local Profile FTUX";
  EventName2["VIEW_LOCAL_PROFILE_COMPLETE_FTUX"] = "View Local Profile Complete FTUX";
  EventName2["CLICK_LOCAL_PROFILE_EXIT_FTUX"] = "Click Local Profile Exit FTUX";
  EventName2["VIEW_LOCAL_PROFILE_PREP_TIME_MODAL"] = "View Local Profile Prep Time Modal";
  EventName2["CLICK_LOCAL_PROFILE_PREP_TIME_MODAL_SAVE"] = "Click Local Profile Prep Time Modal Edit Prep Time";
  EventName2["CLICK_LOCAL_PROFILE_ADD_RESTRICTED_DATE"] = "Click Local Profile Add Restricted Date";
  EventName2["CLICK_LOCAL_PROFILE_EDIT_RESTRICTED_DATE"] = "Click Local Profile Edit Restricted Date";
  EventName2["CLICK_LOCAL_PROFILE_SAVE_RESTRICTED_DATE"] = "Click Local Profile Save Restricted Date";
  EventName2["CLICK_LOCAL_PROFILE_ENABLE_ORDER_SCHEDULING"] = "Click Local Profile Enable Order Scheduling";
  EventName2["CLICK_LOCAL_PROFILE_DISABLE_ORDER_SCHEDULING"] = "Click Local Profile Disable Order Scheduling";
  EventName2["CLICK_LOCAL_PROFILE_EDIT_ORDER_SCHEDULING"] = "Click Local Profile Edit Order Scheduling";
  EventName2["CLICK_NEIGHBORHOODS_SUBMIT_CONTACT_INFO_FORM"] = "Click Neighborhoods Submit Contact Info Form";
  EventName2["CLICK_NEIGHBORHOODS_BOOKING_TIMESLOT"] = "Click Neighborhoods Booking Timeslot";
  EventName2["VIEW_NEIGHBORHOODS_BOOKING_CONFIRMED"] = "View Neighborhoods Booking Confirmed";
  EventName2["VIEW_NEIGHBORHOODS_BOOKING_RESCHEDULED"] = "View Neighborhoods Booking Rescheduled";
  EventName2["VIEW_NEIGHBORHOODS_NUX_MODAL"] = "View Neighborhoods NUX Modal";
  EventName2["COMPLETE_NEIGHBORHOODS_NUX_LESSON"] = "Complete Neighborhoods NUX Lesson";
  EventName2["CLICK_NEIGHBORHOODS_NUX_CTA"] = "Click Neighborhoods NUX CTA";
  EventName2["VIEW_PRE_LIVE_MODAL"] = "View Pre Live Modal";
  EventName2["COMPLETE_PRE_LIVE_LESSON"] = "Complete Pre Live Lesson";
  EventName2["NEIGHBORHOODS_DASHBOARD_PAGE_LOAD"] = "Neighborhoods Dashboard Page Load";
  EventName2["NEIGHBORHOODS_DASHBOARD_LEARN_MORE_CLICK"] = "Neighborhoods Dashboard Learn More Click";
  EventName2["NEIGHBORHOODS_DASHBOARD_SCHEDULE_CALL_CLICK"] = "Neighborhoods Dashboard Schedule Call Click";
  EventName2["NEIGHBORHOODS_DASHBOARD_PAUSE_CONFIRM_CLICK"] = "Neighborhoods Dashboard Pause Confirm Click";
  EventName2["NEIGHBORHOODS_DASHBOARD_TRAINING_CARD_CLICK"] = "Neighborhoods Dashboard Training Card Click";
  EventName2["NEIGHBORHOOD_MESSAGES_EDIT_OR_VIEW_TITLE"] = "edit_title";
  EventName2["NEIGHBORHOOD_MESSAGES_BODY"] = "edit_body";
  EventName2["NEIGHBORHOOD_MESSAGES_CANCEL"] = "cancel";
  EventName2["NEIGHBORHOOD_MESSAGES_SEND"] = "send";
  EventName2["NEIGHBORHOOD_MESSAGES_ATTACH_IMAGE"] = "attach_image";
  EventName2["NEIGHBORHOOD_MESSAGES_ADD_IMAGE"] = "add_image";
  EventName2["NEIGHBORHOOD_MESSAGES_DELETE_IMAGE"] = "delete_image";
  EventName2["NEIGHBORHOOD_MESSAGES_BEGIN_FIRST"] = "begin_first";
  EventName2["NEIGHBORHOOD_MESSAGES_CLOSE"] = "close";
  EventName2["NEIGHBORHOOD_MESSAGES_CHOOSE_IMAGE"] = "choose_image";
  EventName2["NEIGHBORHOOD_MESSAGES_CANCEL_IMAGE_ATTACH"] = "cancel_image_attach";
  EventName2["NEIGHBORHOOD_MESSAGES_SAVE_IMAGE"] = "save_image";
  EventName2["NEIGHBORHOOD_MESSAGES_TRASH_IMAGE"] = "trash_image";
  EventName2["NEIGHBORHOOD_MESSAGES_CONFIRM_SEND"] = "confirm_send";
  EventName2["NEIGHBORHOOD_MESSAGES_CANCEL_SEND"] = "cancel_send";
  EventName2["NEIGHBORHOOD_MESSAGES_BEGIN"] = "begin";
  EventName2["NEIGHBORHOOD_MESSAGES_SAVE_DRAFT"] = "save_draft";
  EventName2["NEIGHBORHOOD_MESSAGES_DISCARD_DRAFT"] = "discard_draft";
  EventName2["NEIGHBORHOOD_MESSAGES_DELETE_DRAFT"] = "delete_draft";
  EventName2["NEIGHBORHOOD_MESSAGES_VIEW_SAVE_DRAFT_CONFIRMATION"] = "view_save_draft_confirmation";
  EventName2["NEIGHBORHOOD_MESSAGES_EDIT_DRAFT"] = "edit_draft";
  EventName2["NEIGHBORHOOD_MESSAGES_VIEW_DELETE_DRAFT_CONFIRMATION"] = "view_delete_draft_confirmation";
  EventName2["NEIGHBORHOOD_MESSAGES_VIEW_ERROR_MESSAGE_DASHBOARD"] = "view_error_message_dashboard";
  EventName2["NEIGHBORHOOD_MESSAGES_VIEW_ERROR_MESSAGE_CREATE"] = "view_error_message_create";
  EventName2["NEIGHBORHOOD_MESSAGES_SEND_INCOMPLETE_MESSAGE"] = "send_incomplete_message";
  EventName2["NEIGHBORHOOD_MESSAGES_SAVE_MISSING_IMAGE"] = "save_missing_image";
  EventName2["NEIGHBORHOOD_MESSAGES_VIEW_MESSAGE_DETAILS"] = "view_message_details";
  EventName2["NEIGHBORHOOD_MESSAGES_DELETE_MESSAGE"] = "delete_message";
  EventName2["NEIGHBORHOOD_MESSAGES_EXIT_MESSAGE_DETAILS"] = "exit_message_details";
  EventName2["NEIGHBORHOOD_MESSAGES_CONFIRM_DELETE_MESSAGE"] = "confirm_delete_message";
  EventName2["NEIGHBORHOOD_MESSAGES_CANCEL_DELETE_MESSAGE"] = "cancel_delete_message";
  EventName2["NEIGHBORHOOD_MESSAGES_VIEW_DELETE_MESSAGE_CONFIRMATION"] = "view_delete_message_confirmation";
  EventName2["NEIGHBORHOOD_MESSAGES_VIEW_ERROR_MESSAGE"] = "view_error_message";
  EventName2["NEIGHBORHOOD_MESSAGES_VIEW_ALL_MESSAGES"] = "view_all_messages";
  EventName2["NEIGHBORHOOD_MESSAGES_VIEW_MESSAGE_BLADE"] = "view_message_blade";
  EventName2["NEIGHBORHOOD_MESSAGES_CLOSE_MESSAGE_BLADE"] = "close_message_blade";
  EventName2["NEIGHBORHOOD_MESSAGES_DUPLICATE_MESSAGE"] = "duplicate_message";
  return EventName2;
})(EventName || {});
var EventLocation = /* @__PURE__ */ ((EventLocation2) => {
  EventLocation2["OVERVIEW"] = "overview";
  EventLocation2["SETTINGS"] = "settings";
  EventLocation2["OVERVIEW_SETUP"] = "overview.setup";
  EventLocation2["OVERVIEW_MENU"] = "overview.menu";
  EventLocation2["OVERVIEW_INCREASE_ORDERS"] = "overview.increase-orders";
  EventLocation2["QR_CODES"] = "qr_codes";
  EventLocation2["QR_CODES_GET_CODES"] = "qr_codes.get_codes";
  EventLocation2["SETTINGS_PICKUP"] = "settings.pickup";
  EventLocation2["SETTINGS_DELIVERY"] = "settings.delivery";
  EventLocation2["NEIGHBORHOODS"] = "neighborhoods";
  EventLocation2["NEIGHBORHOODS_PRE_LIVE"] = "neighborhoods.pre-live";
  EventLocation2["NEIGHBORHOOD_MESSAGES_EDIT_OR_VIEW"] = "neighborhood.messages.edit";
  EventLocation2["MARKETING_OVERVIEW"] = "marketing overview";
  EventLocation2["MARKETING_AUTOMATIONS"] = "marketing automations";
  return EventLocation2;
})(EventLocation || {});
var SellerOnboardingStatus = /* @__PURE__ */ ((SellerOnboardingStatus2) => {
  SellerOnboardingStatus2["NON_SUBSCRIBER"] = "non-subscriber";
  SellerOnboardingStatus2["SUBSCRIBER"] = "subscriber";
  SellerOnboardingStatus2["IN_QUEUE"] = "in-queue";
  SellerOnboardingStatus2["INELIGIBLE"] = "ineligible";
  return SellerOnboardingStatus2;
})(SellerOnboardingStatus || {});
export {
  Activity,
  EventLocation,
  EventName,
  Feature,
  SellerOnboardingStatus
};
//# sourceMappingURL=tracking-events.js.map
